import type { ValueOf } from "@/utils/valueOf";

export const DateLimits = {
  MIN: 59,
  EHD_INFO_THRESHOLD: 73,
  MAX: 204,
} as const;
export type DateLimits = ValueOf<typeof DateLimits>;

export const PricePartsBaby = {
  PREGNANCY_PERIOD: "PregnancyPeriod",
  CHILD_INSURANCE_FIRST_YEAR: "ChildInsuranceFirstYear",
} as const;
export type PricePartsBaby = ValueOf<typeof PricePartsBaby>;
